import React from "react";
import { Route, BrowserRouter, Redirect, Switch } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Videos from "./components/Videos";

import {
  PEER_SERVER_CONFIG as config,
  SOCKET_SERVER_URI,
  EVENTS,
} from "./config";
import socketIOClient from "socket.io-client";
import Peer from "peerjs";

const App = () => {
  var isAdmin = false;

  const generateRoomID = () => {
    isAdmin = true;
    return uuidv4();
  };
  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path={process.env.PUBLIC_URL + "/"}
          render={() => <Redirect to="/home" />}
        />
        <Route
          exact
          path={process.env.PUBLIC_URL + "/home"}
          render={() => "home"}
        />
        <Route
          exact
          path={process.env.PUBLIC_URL + "/golive"}
          render={() => <Redirect to={"/live/" + generateRoomID()} />}
        />
        <Route
          exact
          path={process.env.PUBLIC_URL + "/live/:roomID"}
          render={({ match }) => {
            const socket = socketIOClient(SOCKET_SERVER_URI);
            let peer = new Peer(config);
            peer.on("open", (userID) => {
              socket.emit(EVENTS.CONNECT_ME, {
                isAdmin,
                roomID: match.params.roomID,
                userID,
                socketID: socket.id,
              });
            });
            return (
              <Videos
                isAdmin={isAdmin}
                roomID={match.params.roomID}
                socket={socket}
                peer={peer}
              />
            );
          }}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
